import { render, staticRenderFns } from "./serviceTerms.vue?vue&type=template&id=0113bf2e&scoped=true&"
import script from "./serviceTerms.vue?vue&type=script&lang=js&"
export * from "./serviceTerms.vue?vue&type=script&lang=js&"
import style0 from "./serviceTerms.vue?vue&type=style&index=0&id=0113bf2e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0113bf2e",
  null
  
)

export default component.exports